// extracted by mini-css-extract-plugin
export default {"container":"redirect_container__ilqUr"};